import { registerPlugin } from '@capacitor/core';

const SmartPos = registerPlugin('SmartPos');

class SmartPosBridge {
  static async initSdk() {
    try {
      const result = await SmartPos.initSdk();
      return result;
    } catch (error) {
      console.warn('SmartPos SDK not available:', error);
      throw error;
    }
  }

  static async printText(text, options = {}) {
    const result = await SmartPos.printText({
      text,
      textSize: options.textSize || 25,
      bold: options.bold || false,
      center: options.center !== false,
      cutPaper: options.cutPaper || false
    });
    return result;
  }

  static async printTicket(text) {
    await SmartPosBridge.initSdk();
    return SmartPosBridge.printText(text, { center: true, cutPaper: true });
  }
}

export { SmartPos, SmartPosBridge };
export default SmartPosBridge;
